// de_pms_manager_dashboard.ts
// Tłumaczenia dla ekranu Manager Dashboard (ManagerDashboard.tsx)
// Statusy pokoi, akcje, common labels → importuj z de_pms_common.ts

export const dePmsManagerDashboard = {

  // ── Tytuły modali szczegółów ──────────────────────────────────────────────
  detailTitles: {
    rooms:    { title: "Zimmer und Inventarstatus",        sub: "Live-Zimmerstatus auf allen Etagen" },
    guest:    { title: "Gaesteerlebnis",              sub: "Zufriedenheit, Bewertungen und Service-Recovery (letzte 90 Tage)" },
    dept:     { title: "Abteilungsuebersicht",                 sub: "Status, Arbeitslast und Ausnahmen nach Abteilung (heute)" },
    segments: { title: "Top-Nachfragesegmente",   sub: "Zimmernaechte und Umsatz nach Segment (letzte 28 Tage)" },
    market:   { title: "Markt und Tempo",                    sub: "Benchmark gegen das Comp-Set" },
    labor:    { title: "Personaluebersicht",            sub: "Besetzung und Kosten nach Abteilung (heute)" },
    risk:     { title: "Operative Risikowarteschlange",       sub: "Aktive Risiken mit Handlungsbedarf" },
  },

  // ── Pasek KPI ─────────────────────────────────────────────────────────────
  kpi: {
    occupancy:        "Auslastung",
    adr:              "ADR",
    revpar:           "RevPAR",
    revenueToday:     "Umsatz heute",
    forecastPickup:   "Forecast Pickup",
    guestSatisfaction:"Gaestezufriedenheit",
    openIssues:       "Offene Probleme",
    laborCoverage:    "Personalabdeckung",
    onTheBooks:       "On the books",
    onTarget:         "Auf Kurs",
    belowPlan:        "Unter Plan",
    vsLY:             "vs UB",       // vs Ubiegły Rok
    vsFCST:           "vs PROG",     // vs Prognoza
  },

  // ── Sekcja wykres / Performance & Forecast ────────────────────────────────
  performanceForecast: {
    title:           "Leistung und Prognose",
    legendRevenue:   "Umsatz ($)",
    legendOccupancy: "Auslastung (%)",
    revenueToday:    "Umsatz heute",
    revenueForecast: "Umsatzprognose",
    next7Days:       "naechsten 7 Tage",
  },

  // ── Pokoje i inwentarz ────────────────────────────────────────────────────
  rooms: {
    title:                  "Zimmer und Inventarstatus",
    viewDetails:            "Details anzeigen",
    sellableInventory:      "Verkaufbarer Bestand",
    housekeepingReadiness:  "Housekeeping-Bereitschaft",
    outOfOrder:             "Ausser Betrieb",
    blockedRooms:           "Blockierte Zimmer",
    maintenanceImpact:      "Technischer Einfluss",
    blockedForRevenue:      "Fuer Umsatz blockiert",
    noImpact:               "Kein Einfluss",
    arrivalRoomsNotReady:   "Anreisezimmer nicht bereit",
    highPriority:           "Hohe Prioritaet",
    allClear:               "Alles klar",
    // Szczegóły modalu
    totalRooms:             "Alle Zimmer",
    sellable:               "Verkaufbar",
    occupied:               "Belegt",
    available:              "Verfuegbar",
    dirtyBlocked:           "Schmutzig / blockiert",
    byFloor:                "Nach Etage",
    tableHeaders:           ["Etage", "Gesamt", "Belegt", "Verfuegbar", "Schmutzig", "Reserviert", "A.B."],
    floorLabel:             "Etage",
    reservedForArrivals:    "fuer anstehende Anreisen reserviert",
    room:                   "Zimmer",
    rooms:                  "Zimmer",
    ofTotal:                "% des Gesamt",
    ofOccupancy:            "% Auslastung",
  },

  // ── Doświadczenie gości ───────────────────────────────────────────────────
  guest: {
    title:             "Gaesteerlebnis-Puls",
    viewDetails:       "Details anzeigen",
    satisfactionScore: "Zufriedenheitswert",
    activeComplaints:  "Aktive Beschwerden",
    vipArrivalsToday:  "VIP-Anreisen heute",
    vipInHouse:        "in-house",
    highPriority:      "Hohe Prioritaet",
    noneOpen:          "Keine offenen",
    serviceRecovery:   "Service recovery",
    openCases:         "Offene Faelle",
    reviewSentiment:   "Bewertungssentiment",
    noReviewsYet:      "Noch keine Bewertungen",
    responseSLA:       "Antwort-SLA",
    onTarget:          "Auf Kurs",
    belowTarget:       "Unter Ziel",
    noData:            "Keine Daten",
    noGuestData:       "Keine Gaesteerlebnis-Daten.",
    positiveReviews:   "% positiv",
    reviews:           "Bewertungen",
    // Szczegóły modalu – tabela
    detailLabels: {
      satisfaction:    "Zufriedenheit",
      reviews90d:      "Bewertungen (90d)",
      responseSLA:     "Antwort-SLA",
      complaints:      "Aktive Beschwerden",
      serviceRecovery: "Service recovery",
      openCasesLabel:  "offene Faelle",
      vipTodayInHouse: "VIP heute / in-house",
    },
    sentiment: {
      label:    "Bewertungssentiment",
      positive: "Positiv",
      neutral:  "Neutral",
      negative: "Negativ",
    },
  },

  // ── Przegląd działów ─────────────────────────────────────────────────────
  dept: {
    title:        "Abteilungsuebersicht",
    viewAll:      "Alle anzeigen",
    noData:       "Keine Personaldaten fuer heute.",
    loading:      "Laden...",
    atRisk:       "Gefaehrdet",
    onTrack:      "Im Plan",
    tableHeaders: ["Abteilung", "Status", "Arbeitslast", "Ausn.", "Verantwortlich"],
    detailHeaders:["Abteilung", "Verantwortlich", "Status", "Arbeitslast", "Plan", "Erf.", "Abdeckung", "Ausn."],
  },

  // ── Segmenty popytu ───────────────────────────────────────────────────────
  segments: {
    title:        "Top-Nachfragesegmente",
    stayDate:     "Aufenthaltsdatum",
    viewAll:      "Alle anzeigen",
    noData:       "Keine Aufenthalte in den letzten 28 Tagen.",
    loading:      "Laden...",
    other:        "Andere",
    total:        "Gesamt",
    tableHeaders: ["Segment", "Zimmer", "% des Gesamt", "ADR", "RevPAR"],
    detailHeaders:["Segment", "Zimmernaechte", "% Anteil", "Umsatz", "ADR", "RevPAR"],
  },

  // ── Rynek i tempo ─────────────────────────────────────────────────────────
  market: {
    title:            "Markt und Tempo",
    viewAll:          "Alle anzeigen",
    noData:           "Keine Marktdaten.",
    asOf:             "Stand:",
    marketOccupancy:  "Marktauslastung",
    marketADR:        "Markt-ADR",
    marketRevPAR:     "Markt-RevPAR",
    compSetIndex:     "Comp-Set-Index",
    aboveCompSet:     "Ueber comp set",
    belowCompSet:     "Unter comp set",
    paceToForecast:   "Tempo zur Prognose",
    revenueForecast7d:"Umsatzprognose (7d)",
    vs28dAgo:         "vs. vor 28 Tagen",
    onPace:           "Im Tempo",
    behindPace:       "Zurueck",
    noForecast:       "Keine Prognose",
    description:      "Abweichungen vergleichen den aktuellen Benchmark mit demselben Wert vor 28 Tagen. Ein Comp-Set-Index ueber 100 bedeutet, dass das Objekt den Wettbewerb uebertrifft.",
  },

  // ── Przegląd zatrudnienia ─────────────────────────────────────────────────
  labor: {
    title:         "Personaluebersicht",
    viewAll:       "Alle anzeigen",
    noData:        "Keine Personaldaten.",
    coverage:      "Abdeckung",
    scheduled:     "Geplant",
    totalCost:     "Gesamte Personalkosten",
    vsRequired:    "vs. benoetigt",
    required:      "benoetigt",
    byDept:        "Nach Abteilung",
    noPerDept:     "Keine Daten je Abteilung.",
    onTarget:      "Auf Kurs",
    belowPlan:     "Unter Plan",
    noDataShort:   "Keine Daten",
    revenueOf:     "% des Umsatzes",
    staffingGap:   "Personalengpass",
    fullyCovered:  "Voll abgedeckt",
    tableHeaders:  ["Abteilung", "Plan", "Benoetigt", "Abdeckung", "Verantwortlich"],
  },

  // ── Brief kierowniczy ─────────────────────────────────────────────────────
  leadershipBrief: {
    title:                   "Fuehrungsbriefing",
    todaySummary:            "Tageszusammenfassung",
    upcomingHighlights:      "Bevorstehende Highlights",
    notes:                   "Notizen",
    noActiveNotes:           "Keine aktiven Notizen. Fuege eine im Live Board hinzu.",
    noUpcomingGroupBlocks:   "Keine bevorstehenden Gruppenbloecke",
    pickupVsYesterday:       "Pickup vs. gestern",
    revenuePace:             "Umsatztempo",
    compSetIndex:            "Comp Set Index",
    displacement:            "Verdraengung",
    today:                   "heute",
    groupPrefix:             "Gruppe: ",
    noReleaseDate:           "Kein Release-Datum",
    rooms:                   "Zimmer",
    room:                    "Zimmer",
    pickupOf:                "pickup",
  },

  // ── Kolejka ryzyk ─────────────────────────────────────────────────────────
  risk: {
    title:    "Operative Risikowarteschlange",
    viewAll:  "Alle anzeigen",
    noRisks:  "Keine aktiven operativen Risiken",
    loading:  "Laden...",
  },

} as const;

export default dePmsManagerDashboard;
